var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10156 4.60156L5.57812 0.3125C5.71875 0.195312 5.85938 0.125 6 0.125C6.14062 0.125 6.25781 0.171875 6.375 0.265625L10.8516 4.55469C11.0859 4.78906 11.0859 5.14062 10.875 5.35156C10.6641 5.58594 10.3125 5.58594 10.0781 5.375L6 1.48438L1.875 5.42188C1.66406 5.63281 1.28906 5.63281 1.07812 5.39844C0.867188 5.16406 0.867188 4.8125 1.10156 4.60156Z",
    fill: "#2E3844"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.07a91f941291a6b96a59660267d56557.svg";
export { ForwardRef as ReactComponent };